// data/tiktokPixelEvent.js
// Defines the expected parameters for standard TikTok Pixel events.
// Reference: https://ads.tiktok.com/help/article/standard-events-parameters

module.exports = {
  "Purchase": ["content_id", "content_name", "content_type", "currency", "value", "quantity", "description"],
  "CompletePayment": ["content_id", "content_name", "content_type", "currency", "value", "quantity", "description"],
  "PlaceAnOrder": ["content_id", "content_name", "content_type", "currency", "value", "quantity", "description"],
  "AddToCart": ["content_id", "content_name", "content_type", "currency", "value", "quantity", "description"],
  "AddToWishlist": ["content_id", "content_name", "content_type", "currency", "value", "quantity", "description"],
  "InitiateCheckout": ["content_id", "content_name", "content_type", "currency", "value", "quantity", "description"],
  "AddPaymentInfo": ["content_id", "content_name", "content_type", "currency", "value", "quantity", "description"],
  "ViewContent": ["content_id", "content_name", "content_type", "currency", "value", "quantity", "description"],
  "Search": ["content_id", "content_name", "content_type", "currency", "value"],
  "CompleteRegistration": ["content_name", "currency"],
  "Subscribe": ["currency", "value"],
};
